import { ErrorHandler, Injectable } from '@angular/core';

// SA-8637: Sentry loaded from CDN (see src/index.html + src/types/sentry-cdn.d.ts).

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const extractedError = error.originalError || error.rejection || error;

    // SA-8637: defensive guard — see sentry.utils.ts.
    if (typeof Sentry !== 'undefined') {
      Sentry.captureException(extractedError, {
        tags: {
          source: 'angular-uncaught'
        }
      });
    }

    // Preserve default Angular logging behaviour
    console.error(error);
  }
}
